import React from 'react';
import useSavePreferencesModal from 'utils/hooks/meteorology/useSavePreferencesModal';
import Dialog from 'components/DesignSystem/Dialog';
import SavePreferencesForm from './savePreferencesForm';

export default function SavePreferencesModal() {
  const { setShowFormModal, isShowingFormModal } = useSavePreferencesModal();

  return (
    <Dialog
      open={isShowingFormModal}
      dismiss={() => { setShowFormModal(false); }}
      closeButton
    >
      <Dialog.Body>
        <SavePreferencesForm />
      </Dialog.Body>
    </Dialog>
  );
}
